import React, { useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const today = () => new Date().toISOString().slice(0, 10);
const EMPTY = { kind: "sale", date: today(), label: "", party: "", number: "", amount: "", mode: "" };

// Admin: manual entry of goods sales / goods purchases (sold outside SUX1).
export function AdminLedgerEntryForm({ onAdded }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/ledger/entries", { ...f, amount: Number(String(f.amount).replace(",", ".")) });
      toast.success(f.kind === "sale" ? "Vente de marchandise ajoutée." : "Achat ajouté.");
      setF({ ...EMPTY, kind: f.kind, date: f.date });
      onAdded();
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(Array.isArray(d) ? "Vérifiez la date, la désignation et le montant." : d || "Échec de l'ajout.");
    } finally {
      setBusy(false);
    }
  };

  const inp = "border border-border bg-background px-3 py-2 text-sm min-w-0";
  const isSale = f.kind === "sale";
  return (
    <form onSubmit={submit} className="border border-dashed border-[#002FA7] p-4 mb-4" data-testid="admin-ledger-entry-form">
      <div className="flex gap-2 mb-3">
        {[["sale", "Vente de marchandise"], ["purchase", "Achat de marchandise"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setF({ ...f, kind: k })} data-testid={`admin-ledger-kind-${k}`}
            className={`font-mono uppercase tracking-[0.15em] text-[10px] px-3 py-2 border border-[#002FA7] transition-colors ${f.kind === k ? "bg-[#002FA7] text-white" : "text-[#002FA7]"}`}>
            {l}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        <input type="date" className={inp} value={f.date} onChange={set("date")} required data-testid="admin-ledger-entry-date" />
        <input className={inp} value={f.label} onChange={set("label")} required placeholder="Désignation (ex. livre d'occasion)" data-testid="admin-ledger-entry-label" />
        <input className={inp} value={f.amount} onChange={set("amount")} required inputMode="decimal" placeholder="Montant € (ex. 12,50)" data-testid="admin-ledger-entry-amount" />
        <input className={inp} value={f.party} onChange={set("party")} placeholder={isSale ? "Client" : "Fournisseur"} data-testid="admin-ledger-entry-party" />
        <input className={inp} value={f.number} onChange={set("number")} placeholder="N° facture (facultatif)" data-testid="admin-ledger-entry-number" />
        <input className={inp} value={f.mode} onChange={set("mode")} placeholder="Paiement (ex. virement, Leboncoin)" data-testid="admin-ledger-entry-mode" />
      </div>
      <button type="submit" disabled={busy} data-testid="admin-ledger-entry-submit"
        className="mt-3 font-mono uppercase tracking-[0.2em] text-[11px] px-5 py-2 text-white bg-[#002FA7] hover:bg-[#00227A] transition-colors disabled:opacity-50 flex items-center gap-2">
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Plus className="w-3 h-3" />} Ajouter
      </button>
    </form>
  );
}

export default AdminLedgerEntryForm;
